module.exports = __webpack_public_path__ + "static/media/iris_editor.f8b954dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/iris_editor.png
// module id = 631
// module chunks = 0 1 2